export const LOCAL_STORAGE = {
    BASIC_INFO: 'basicInfo',
    IS_IMPERSONATING: 'isImpersonating',
    HISTORY_LIST: 'historyList',
    CALLBACK_REQUESTED: 'callbackRequested',
    BASIC_PROFILE_FORM_VALUES: 'basicProfileFormValues',
    ADDRESS_FORM_VALUES: 'addressFormValues',
    LEXIKTOKEN: 'lexiktoken',
    REFRESH_TOKEN: 'refreshToken',
    LAST_REFRESHED: 'lastRefreshed',
    INITIAL_TOKEN: 'initialToken',
    INITIAL_BASIC_INFO: 'initialBasicInfo',
    REDIRECT_URL: 'redirectUrl',
    AUTH_ERROR_MESSAGE: 'authErrorMessage',
    // sessionStorage, like REDIRECT_URL and AUTH_ERROR_MESSAGE: it must survive the Login page's
    // localStorage.clear() and the cross-origin Keycloak round-trip, but not follow into new tabs.
    OIDC_SILENT_LOGIN_ATTEMPTED: 'oidcSilentLoginAttempted',
    OIDC_INTERACTIVE_LOGIN_ATTEMPTED: 'oidcInteractiveLoginAttempted',
    REFERRAL_EXCLUDED_IDS: 'referralExcludedIds',
    REFERRAL_FORM_VALUES: 'referralFormValues',
    UNAUTHENTICATED_PROFESSIONAL_ID: 'unauthenticatedProfessionalId',
    UNAUTHENTICATED_LEXIKTOKEN: 'unauthenticatedLexiktoken',
    HAS_COMPLETED_FEES_SIGN_UP: 'hasCompletedFeesSignUp',
    NEW_ADVISER: 'newAdviser',
};
